import React, {Component} from 'react';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';

import { toggleSaveEditPopup, toggleNotification, toggleManagerPopup } from '../../redux/reducers/view';
import { resetPathToSaveVersion, saveVersionRequest, overwriteVersionRequest } from '../../redux/reducers/savedVersions';

import Popup from '../Popup';
import SaveEditForm from '../Form/SaveEditForm';

import { commonStyles, COLORS } from '../../styles/styles';
import questions from '../../assets/questions-circular.svg';
import VersionNameField from '../Form/VersionNameField';
import { Field, reduxForm } from 'redux-form';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBIcon } from 'mdbreact';
import { validateApproval } from '../Form/validate';
import { resetSaveEditForm } from '../../redux/reducers/annotations';
import { versionStatusRequest } from '../../redux/reducers/versionStatus';
import { selectedVersion, selectedContent, getSelectedThinktool } from '../../redux/selectors';
import { xapiRequest } from '../../redux/reducers/xapi';
import TextField from '../Form/TextField';
import SignatureCanvas from 'react-signature-canvas'
import ManagerTerms from '../Form/ManagerTerms';
import moment from 'moment';
import * as html2canvas from 'html2canvas';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';
import { getSelectedContent } from '../../utils';
import { setLogbookImage } from '../../redux/reducers/userProgramsFull';
import { API_LINK } from '../../constants';
import axios from 'axios';
import { STORAGE_LINK } from '../../constants';
class LogbookPopup extends Component {
  state = {
    modal: true,
    trySend:false,
    showImage:false,
    img:null
  };

  toggle = () => {
    
    this.props.toggleManagerPopup(false)
  }

  test2 =() => {
    this.setState({trySend:false})
  }

  onBackClick =() => {
    this.setState({trySend:false})
    this.setState({showImage:false})
  }

  // Function to handle the file upload
 handleFileUpload = async (userId, surveyId, file) => {
  try {
    const formData = new FormData();
    formData.append('user_id', userId);
    formData.append('survey_id', surveyId);
    formData.append('file', file);

    const response = await axios.post(API_LINK + 'api/uploadWSR', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    this.props.setLogBookImage(response.data);
    this.setState({img:response.data})// Handle the response data as needed
  } catch (error) {
    console.error(error);
    // Handle error cases
  }
};

convertDivToImage = async () => {
  try {
    document.getElementById("test").scrollTop = 0;
    var w = document.getElementById("test").width;
    var h = document.getElementById("test").height;
    document.getElementById("test").style.height="auto";
    const canvas = await html2canvas(document.getElementById("test"));
    canvas.toBlob((blob) => {
      const file = new File([blob], 'image.png', { type: 'image/png' });
      // Call the handleFileUpload function with the created file
      this.handleFileUpload(this.props.user.user.userId, this.props.view.managerPopup.survey_id, file);
    }, 'image/png');
    this.setState({trySend:false});
    this.setState({showImage:true})
  } catch (error) {
    console.error(error);
    // Handle error cases
  }
};


  handleSubmitManager = values => {
    // props.xapiRequest({ xapiType: `Manager Approval`});
    validateApproval(values);
    // props.saveVersionRequest();
    if(!this.sigCanvas.isEmpty()){
    //   this.setState({trySend:true})
    //   document.getElementById("test").scrollTop = 0;
    //   var w = document.getElementById("test").width;
    //   var h = document.getElementById("test").height;
    //  document.getElementById("test").style.height="auto";
    //   html2canvas(document.getElementById("test")).then(canvas => {
        
    //     var snap = canvas.toDataURL();
        
    //     this.props.setLogBookImage(snap);
    //     this.setState({trySend:false});
    //     // this.props.handleSubmitLog(this.props.view.managerPopup)
    //     // this.props.toggleManagerPopup(false)
    //     this.setState({showImage:true})
    //   });
      this.convertDivToImage()
    }
  }
  handleSubmitManager2 = values => {
    // props.xapiRequest({ xapiType: `Manager Approval`});
   
        this.props.handleSubmitLog(this.props.view.managerPopup)
        this.props.toggleManagerPopup(false)
      
  }

  render() {

    const checkboxValue =
    this.props.formState.managerForm &&  this.props.formState.managerForm.values &&  this.props.formState.managerForm.values.ManagerTerms;
    
    return (
      <MDBContainer style={{zIndex:2050}} >
        <MDBModal isOpen={this.props.view.managerPopup} toggle={this.toggle}  centered   >
         
          <MDBModalHeader style={{textAlign:'left', margin: 5}} className="secondary-color" toggle={this.toggle}><div style={{color: '#ffffff !important'}}>Manager Approval Declaration</div> </MDBModalHeader>
          {!this.state.showImage ? <form onSubmit={this.props.handleSubmit(this.handleSubmitManager)}>
          <div id='test'><MDBModalBody>
          <Field name="managername" label="Manager Name" component={TextField}  />
          <Field name="manageremail" label="Manager Email" component={TextField}  />
          <Field name="managernumber" label="Manager Contact #" component={TextField}  />
          <Field name="managerid" label="Manager Employee or ID #" component={TextField}  />
          <div className="mb-2 mt-2">
            Manager Signature
          </div>
          <div style={{margin:5}}>
      
          <SignatureCanvas ref={(ref) => { this.sigCanvas = ref }} penColor='black'
           backgroundColor='rgba(0,0,0,.1)'
    canvasProps={{width: 450, height: 200, className: 'sigCanvas'}} />
     <MDBBtn
              style={{position:'absolute', right:30, bottom:200}}
              disabled={this.props.submitting}
              onClick={() => this.sigCanvas.clear()}
              color='secondary'
            >
              CLEAR
            </MDBBtn>
    </div>
    <div className="mb-2 mt-2">
            Date Signed:  {moment(new Date()).format('DD/MM/YYYY')}
          </div>
          {this.sigCanvas && this.sigCanvas.isEmpty() && (
      <div style={{position:'relative', margin:20, top:10}}><MDBAlert color="danger" >
     Signature is required
      </MDBAlert>
      </div>
     
    )}

     <Field
              name="ManagerTerms"
              component={ManagerTerms}
              label=""
              checkedStatus={checkboxValue}
             
            />
    
  
          </MDBModalBody></div>
          <MDBModalFooter>
          <MDBBtn
            color='success'

            type="submit"
            disabled={!checkboxValue}
            >
            PROCESS
            </MDBBtn>
           
            <MDBBtn
              onClick={() => this.props.onCloseClick()}
              color='secondary'
            >
              CANCEL
            </MDBBtn>

          </MDBModalFooter>
          </form> : <MDBModalBody>
          <div style={{position:'relative', margin:20, top:10}}><MDBAlert color="danger" >
     Is the image below correct and able to to be sent?
      </MDBAlert>
      </div>
            <img src={STORAGE_LINK+this.state.img} style={{width:'100%'}}/>
            <MDBModalFooter>
          <MDBBtn
            color='success'
            onClick = {() => this.handleSubmitManager2()}
            >
            SUBMIT 
            </MDBBtn>
           
            <MDBBtn
              onClick={() => this.onBackClick()}
              color='secondary'
            >
              BACK
            </MDBBtn>
            </MDBModalFooter></MDBModalBody>}
          <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{this.state.trySend && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
        color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>
        </MDBModal>
      </MDBContainer>
    );
  }
}


const styles = () => ({
  ...commonStyles,
  image: {
    width: 64,
    height: 64,
  },
});

const mapStateToProps = state => ({
  formState: state.form,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  view: state.viewReducer,
  version: selectedVersion(state),
  selectedContent: getSelectedContent(state),
  user: state.loginReducer
});
const mapDispatchToProps = dispatch => ({
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  resetSaveEditForm: () => dispatch(resetSaveEditForm()),
  toggleManagerPopup: value => dispatch(toggleManagerPopup(value)),
  setLogBookImage: value => dispatch(setLogbookImage(value)),
  toggleNotification: value => dispatch(toggleNotification(value)),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
  resetPathToSaveVersion: () => dispatch(resetPathToSaveVersion()),
  versionStatusRequest: () => dispatch(versionStatusRequest()),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),
});

export default compose(
  reduxForm({
    form: 'managerForm',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isShowPopup', 'togglePopup', false),
  withHandlers({
   
    onCloseClick: props => () => {
      props.toggleManagerPopup(false)
    },
    handlePopupToggle: props => item => {
      const { isShowPopup, xapiRequest, getUserProgramsFullRequest } = props;
     
      
     
      //xapiRequest({ xapiType: `${xapiType}`});
      if (isShowPopup) {
        getUserProgramsFullRequest();
      }
      props.togglePopup(!isShowPopup);
    },
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const {
        toggleNotification,
        toggleSaveEditPopup,
        savedVersions,
        versionStatusRequest,
      } = nextProps;
    },
  }),
  withStyles(styles),
)(LogbookPopup);

LogbookPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  savedVersions: PropTypes.instanceOf(Object),
  userProgramsFull: PropTypes.instanceOf(Object),
  handleOverwrite: PropTypes.func,
};
